module.exports = __webpack_public_path__ + "img/cases_illustration_phone.208ce191.svg";